var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"px-3 py-2 text-dark"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }